import { Extension, Lexical } from '@37signals/lexxy'
import { $generateNodesFromDOM } from '@lexical/html'
import type { LexicalCommand, LexicalEditor } from 'lexical'

const { $createParagraphNode, $getRoot, $insertNodes, COMMAND_PRIORITY_EDITOR } = Lexical

// Lexxy's toolbar dispatches each button's data-command by name
function toolbarCommand<T> (name: string): LexicalCommand<T> {
  return name as unknown as LexicalCommand<T>
}

export class CommandsExtension extends Extension {
  get lexicalExtension (): unknown {
    return this.defineExtension({
      name: 'hoot/commands',
      register: (editor: LexicalEditor) => Lexical.mergeRegister(
        editor.registerCommand(toolbarCommand<string>('insertHtml'), html => {
          $insertNodes($generateNodesFromDOM(editor, new DOMParser().parseFromString(html, 'text/html')))
          return true
        }, COMMAND_PRIORITY_EDITOR),
        editor.registerCommand(toolbarCommand<undefined>('clearContent'), () => {
          $getRoot().clear().append($createParagraphNode()).selectStart()
          return true
        }, COMMAND_PRIORITY_EDITOR)
      )
    })
  }
}
